import { fullName } from '../../../../common/helpers/users';
import {
  INIT_FILTER,
  UPDATE_FILTER,
  FILTER_SELECT_ALL,
  FILTER_DESELECT_ALL,
} from '../constants';

const transformShopsToFilter = shops => shops.map(item => ({
  id: item.id,
  title: item.name,
  checked: true,
  type: 'shop',
}));

const transformBarbersToFilter = barbers => barbers.map(item => ({
  id: item.id,
  title: fullName(item),
  checked: true,
  type: 'barber',
}));

const customReportFilters = (filterType, transformToFilter) => (state = [], action) => {
  if (action.filterType !== filterType) {
    return state;
  }

  switch (action.type) {
    case INIT_FILTER:
      return transformToFilter(action.payload);
    case UPDATE_FILTER:
      return state.map((filter) => {
        if (filter === action.payload) {
          return {
            ...filter,
            checked: !filter.checked,
          };
        }
        return filter;
      });
    case FILTER_SELECT_ALL:
      return state.map(filter => ({
        ...filter,
        checked: true,
      }));
    case FILTER_DESELECT_ALL:
      return state.map(filter => ({
        ...filter,
        checked: false,
      }));
    default:
  }
  return state;
};

const shopFilters = customReportFilters('shop', transformShopsToFilter);
const barberFilters = customReportFilters('barber', transformBarbersToFilter);

export { shopFilters, barberFilters };
